import React from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {Container} from '@modifi/ui'

import {Video, Iframe} from './styles'
import {DefaultComponentWrapper} from '../common'

const propTypes = {
  videoUrl: PropTypes.string,
  videoPoster: PropTypes.string,
  youtubeEmbedVideoUrl: PropTypes.string,
  backgroundColor: PropTypes.string,
}
const defaultProps = {
  videoUrl: '',
  videoPoster: '',
  youtubeEmbedVideoUrl: '',
  backgroundColor: undefined,
}

export type VideoComponentProps = InferPropTypes<typeof propTypes, typeof defaultProps>

export const VideoComponent: React.FC<VideoComponentProps> = ({
  videoUrl,
  videoPoster,
  youtubeEmbedVideoUrl,
  backgroundColor,
}) => (
  <DefaultComponentWrapper backgroundColor={backgroundColor} padding={0}>
    <Container>
      {youtubeEmbedVideoUrl ? (
        <Iframe
          width="100%"
          src={`${youtubeEmbedVideoUrl}?modestbranding=1&rel=0`}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
      ) : (
        <Video loop width="100%" poster={videoPoster} controls data-testid="video-element">
          <source src={videoUrl} type="video/webm" />
          <source src={videoUrl} type="video/mp4" />
        </Video>
      )}
    </Container>
  </DefaultComponentWrapper>
)

VideoComponent.propTypes = propTypes

VideoComponent.defaultProps = defaultProps

export default VideoComponent
